import React, { useMemo } from "react";
import { HorizontalBar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DonorDeferralReasonsChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: data.reasons.map((reason) => t(reason)),
      datasets: [
        {
          label: t("Number of Deferrals"),
          data: data.counts,
          backgroundColor: "#dc3545",
          borderColor: "#dc3545",
          borderWidth: 1,
          barThickness: 25,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of Deferrals"),
            fontColor: "#666",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Deferrals")}: ${tooltipItem.xLabel}`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "250px", position: "relative" }}>
      <HorizontalBar data={chartData} height={250} options={options} />
    </div>
  );
};

export default DonorDeferralReasonsChart;
